import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import PricingCard from '../components/pricing/PricingCards'; // o la ruta donde guardaste PricingCard

const PricingPage = () => {
  const pricingOptions = [
    {
      title: 'Chequeo',
      price: 10,
      features: ['Acceso básico', 'Registro de asistencia', 'Reportes simples'],
      buttonText: 'Seleccionar Plan',
      priceId: 'price_1R1HKdG0Naw3htQoHBbXNLyA'
    },
    {
      title: 'Evento',
      price: 20,
      features: ['Todo lo de Chequeo', 'Gestión de eventos', 'Reportes avanzados', 'Soporte prioritario'],
      buttonText: 'Seleccionar Plan',
      priceId: 'price_1R1tMOG0Naw3htQoRjCxGQK4'
    },
    {
      title: 'Inscripciones',
      price: 5,
      features: ['Registro básico', 'Gestión de inscripciones', 'Notificaciones'],
      buttonText: 'Seleccionar Plan',
      priceId: 'price_1R1snsG0Naw3htQod68SVXVX'
    }
  ];

  console.log("pricingOptions: ", pricingOptions)

  return (
    <Box sx={{ py: 8, px: 2 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Planes y Precios
      </Typography>
      <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
        {pricingOptions.map((option, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <PricingCard {...option} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PricingPage;
